import {getPageDesByCode} from "@/api";
import {deepClone} from 'xmgoing-utils'
import {usePageModelsStore} from "@/store/modules/pageModels";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import eventBus from "@/events/eventBus";

export function usePageDesHook() {
  const pageConfigs = ref({});
  const pageModelsStore = usePageModelsStore();
  const dataSourceStore = useDataSourceStore();
  /**
   * 加载之后的操作
   * @param versionItem
   */
  const afterLoadRecord = function ({versionItem}) {
    //设计信息
    const infoSettingJson = versionItem?.infoSettingJson;
    //数据源信息
    const dataSourceConfig = versionItem?.infoSettingJsonTwo;
    if (infoSettingJson) {
      pageConfigs.value = typeof infoSettingJson === 'string' ? JSON.parse(infoSettingJson) : infoSettingJson;
      pageModelsStore.initStoreByConfig(pageModelsStore, pageConfigs);
      if (dataSourceConfig && dataSourceConfig!)
        dataSourceStore.setDataSourceList(typeof dataSourceConfig === 'string' ? JSON.parse(dataSourceConfig) : dataSourceConfig, pageModelsStore);
    }
  }
  /**
   * 加载页面设计信息
   */
  const loadPageDes = async function ({
                                        pageCode,
                                        moduleCode,
                                        pageTitle,
                                        width = 860,
                                        height = 520
                                      }) {
    const res = await getPageDesByCode({pageCode, moduleCode});
    afterLoadRecord({versionItem: res});
    eventBus.emit('onOpenWin', {config:{
        wWidth: unref(width),
        wHeight:unref(height),
        wTitle: '',
        cancelBtn:false,
        contentKey: '',
        contentFrom: '',
        pageConfigVal: deepClone(unref(pageConfigs)),
        maskFlagVal:false,
        maskClosableVal:true,
        pageCode:pageCode,
        moduleCode:moduleCode
      }});
    // defPageStore.setPageId(pageCode);
    // defPageStore.setPageConfig(
    //   {
    //     pageId: pageCode,
    //     params: {},
    //     container: {
    //       type: 'user-def-win',
    //       height,
    //       width,
    //       title: pageTitle,
    //       cancelBtn: false,
    //       confirmBtn: false,
    //       show: true
    //     },
    //     pageConfigs: deepClone(unref(pageConfigs))
    //   }
    // )
  }

  return {
    loadPageDes
  }
}
